<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    content-class="menu-date-time-picker"
    offset-y
    max-width="300"
    min-width="300"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        readonly
        filled
        outlined
        dense
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
        :label="$t('fines.table.date')"
        :value="dateTime"
        :rules="rules"
      />
    </template>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-date-picker
          v-model="date"
          class="elevation-0"
          full-width
          no-title
          :allowed-dates="allowedDates"
          :locale="$i18n.locale"
        />
        <v-btn
          class="d-block ml-auto mr-3"
          color="warning"
          elevation="0"
          text
          :disabled="!date"
          @click="tab = 1"
        >
          {{ $t('common.button.next') }}
        </v-btn>
      </v-tab-item>
      <v-tab-item>
        <v-btn class="menu-date-time-picker__back" icon @click="tab = 0">
          <v-icon size="27" color="#eee">mdi-arrow-left</v-icon>
        </v-btn>

        <v-time-picker
          v-model="time"
          format="24hr"
          class="elevation-0 menu-date-time-picker__time"
          full-width
        />

        <div class="menu-date-time-picker__buttons">
          <v-btn
            class="d-block ml-auto mr-3"
            color="warning"
            elevation="0"
            text
            :disabled="!time"
            @click="save"
          >
            {{ $t('common.btns.ok') }}
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-menu>
</template>

<script>
export default {
  props: {
    dateTime: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    menu: false,
    tab: 0,
    date: '',
    time: '',
  }),
  watch: {
    menu(val) {
      if (!val) {
        this.tab = 0;
        this.date = '';
        this.time = '';
      } else {
        if (!this.dateTime) return;

        const [date, time] = this.dateTime.split(' ');
        this.date = date;
        this.time = time;
      }
    },
  },
  computed: {
    rules() {
      const rules = [];

      if (!this.menu) rules.push(this.isRequired);

      return rules;
    },
  },
  methods: {
    isRequired(v) {
      const isValid = Boolean(v) || v === 0;
      return isValid || this.$t('common.fields.validation.field.required');
    },
    allowedDates(value) {
      const nextDate = new Date(value);
      return nextDate < new Date();
    },
    save() {
      const time = `${this.date} ${this.time}`;
      const withSeconds = time.length === 19;

      this.menu = false;
      this.$emit('change', withSeconds ? time : `${time}:00`);
    },
  },
};
</script>

<style lang="scss">
.menu-date-time-picker {
  background-color: #fff;
  padding-bottom: 10px;

  &__time {
    .v-time-picker-title {
      justify-content: center;
    }

    .v-time-picker-title__time,
    .v-time-picker-title__time span,
    .v-picker__title__btn {
      font-size: 25px;
      height: 25px;
    }
  }

  &__back {
    position: absolute;
    top: 10px;
    left: 5px;
    z-index: 10;
  }

  &__buttons {
    margin-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .v-time-picker-title {
    justify-content: center;
  }

  .v-btn--text {
    text-decoration: none !important;
  }
}
</style>
